export default __webpack_public_path__ + "static/media/combot-white-no-horn.0dda2485.svg";